export default "__VITE_ASSET__TyZ$QfsP__"